import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import {
  SUMMARY_CHIP_FONT_SIZE,
  SUMMARY_CHIP_HEIGHT,
  SUMMARY_CHIP_LETTER_SPACING,
  SUMMARY_CHIP_PADDING,
  SUMMARY_CHIP_RADIUS_CSS
} from "./summary-header-constants";

const SummaryChip = withLiteObserverAndTheme<{
  label: string;
  toneColor: string;
  backgroundColor: string;
}>((props) => {
  const { label, toneColor, backgroundColor, theme } = props;
  const { unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={0}
      height={SUMMARY_CHIP_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={backgroundColor}
      style={{
        boxSizing: "border-box",
        width: "auto",
        flexShrink: 0,
        whiteSpace: "nowrap",
        border: `1px solid ${toneColor}`,
        borderRadius: SUMMARY_CHIP_RADIUS_CSS,
        paddingLeft: SUMMARY_CHIP_PADDING * unitX,
        paddingRight: SUMMARY_CHIP_PADDING * unitX
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={SUMMARY_CHIP_FONT_SIZE}
        text={label}
        isSpan={true}
        color={toneColor}
        style={{
          margin: 0,
          textTransform: "uppercase",
          letterSpacing: SUMMARY_CHIP_LETTER_SPACING
        }}
      />
    </ET3Div>
  );
});
export default SummaryChip;
